import React from 'react';
import vmcLogo from '../../images/logo1.svg';
import { Link } from 'react-router-dom';
import translate from '../../i18n/translate';
import { BASE_URL } from 'utils/constants';
import parse from 'html-react-parser';

const News = ({ article, textLength = 200 }) => {
  return (
    <div className="news d-flex justify-between">
      <Link to={'/articles/' + article.id}>
        <div className="news-image-container">
          <img
            className="news-image"
            alt="news"
            src={
              article.images.length > 0
                ? `${BASE_URL}/${article.images.pop().url}`
                : vmcLogo
            }
          ></img>
        </div>
      </Link>
      <div className="news-info">
        <Link to={'/articles/' + article.id}>
          <h5>{article.title}</h5>
          <span className="news-info-date">{article.date}</span>
        </Link>
        <p className="news-info-text">
          {article.description &&
            parse(article.description.substring(0, textLength))}
          ...
        </p>
        <div className="read-more-box">
          <Link to={'/articles/' + article.id} className="text-box-read-more">
            {translate('readMore')}...
          </Link>
        </div>
      </div>
    </div>
  );
};

export default News;
